// IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке): ОБЩАЯ ЛОГИКА ПАНЕЛИ ЗАДАЧ СТОЛА — её используют вкладка «Tasks panel» формы
// стола (components_core/AttrTasksPanel.vue) и панель задач в шапке у администратора (AppTopbar.vue). Строки doc.data_tasks
// (attrs.attrs_viewTasks / prepare_taskTree: node {value, valueStr, attr_type, relation_segment, pi}; статусы последнего лога кладёт
// log.scan_log_multi: status, status_comment, created_at, cssClass-status) → пункты MenuPanel:
//   · раскладка «по-1С» (tasksPanel_flatten): чистая папка (Tab / Text без ссылки) с собственными пунктами — группа (колонка), вложенные чистые
//     папки идут следом в порядке дерева (одноимённая — с именем родителя); ссылка с детьми — пункт-папка внутри группы; пункты вне папок —
//     в группу runsTitle (MenuPanel); use=false — пункт приглушён (и его потомки);
//   · значок пункта — node.pi (иконка сегмента с бэка), иначе иконка сегмента из словаря SEGMENTS (у подсегмента без иконки — родителя),
//     иначе по типу узла; бейдж — статус последнего лога из словаря STATUS (title + cssClass элемента, как пилюля статуса в гриде);
//   · запись, которую открывает пункт (tasksPanel_openOf / tasksPanel_openAction) — только узел AttrLink: id = node.value,
//     segment = node.relation_segment (тот же путь, что двойной клик дерева);
//   · tasksPanel_errors — число ЗАДАЧ (уникальных node.value узлов-ссылок) со статусом последнего запуска STATUS-error: красный бейдж иконки шапки.
// Чистые функции: словари, формат дат и перевод приходят контекстом ctx = { dictRow(segment, id), formatDate(iso) → текст, t(text, params),
// paste: {record, segment} | null, titleFor(id, segment) → название }. Юнит на чистой части — handoff-files/tasks-topbar-2026-09-23/tasksPanel.test.mjs.
// IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке — названия): узел-ссылка БЕЗ названия — node.valueStr пуст или равен id. Факт (замер 23.09,
// dev и dev02): в ответе «только вид» widget_open записи стола так у ВСЕХ узлов-ссылок (98 из 98 / 109 из 109) — attrs.prepare_attrs →
// prepare_AttrMulti_itemsSource_row → prepare_AttrMulti без select_valueStr переписывает valueStr значением (код 2024 10); форма стола возвращает
// названия вторым запросом select_log (loading формы), которого у снимка панели нет. Название такого узла даёт ctx.titleFor(id, segment)
// (mainStore.tasksBar_title — кэш ← бэк catalog_titles, иначе словарь сегмента); без ctx.titleFor — прежнее поведение (id) — так живёт вкладка формы
import { treeNode_pi } from './treeNodeIcon.js'   // IE 2026 10 24 / ODOO-348705 (заказ Игоря: иконка ссылки на список в дереве — как ярлык списка)
export const TYPE_ICON = { AttrTab: 'pi pi-folder', AttrStr: 'pi pi-minus', AttrLink: 'pi pi-file' }
export const STATUS_ERROR = 'STATUS-error'

const stripTags = (s) => String(s || '').replace(/<[^>]*>/g, '')
const withPi = (pi) => { const t = String(pi || '').trim().replace(/^pi\s+/, ''); return t ? 'pi ' + t : '' }
const identityT = (text, params) => String(text || '').replace(/\{(\w+)\}/g, (m, k) => (params && k in params) ? String(params[k]) : m)
const isObj = (x) => !!(x && typeof x === 'object')

// IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке — названия): узел-ссылка без названия (valueStr пуст / равен id, у строки нет title / widget)
export function tasksPanel_bare(r) {
    const n = r?.node
    if (!n || n.attr_type !== 'AttrLink' || n.value == null || n.value === '') return false
    if (r.title || r.widget) return false
    const vs = n.valueStr
    return vs == null || vs === '' || String(vs) === String(n.value)
}

// id (с сегментом) узлов-ссылок без названия — уникальные, в порядке дерева: их названия запрашиваются пачкой (mainStore.tasksBar_resolveTitles)
export function tasksPanel_bareIds(rows) {
    const seen = new Set(), out = []
    tasksPanel_walk(rows, (r) => { if (!tasksPanel_bare(r)) return; const id = String(r.node.value); if (seen.has(id)) return; seen.add(id); out.push({ id, segment: String(r.node.relation_segment || '') }) })
    return out
}

// заголовок строки дерева — как колонка Title; у узла-ссылки без названия — ctx.titleFor(id, segment) (кэш стора / словарь), иначе как раньше (id)
export function tasksPanel_titleOf(r, ctx) {
    const n = r?.node || {}
    if (ctx && typeof ctx.titleFor === 'function' && tasksPanel_bare(r)) {   // IE 2026 09 23 (заказ Игоря: панель задач в шапке — названия)
        let t = ''
        try { t = ctx.titleFor(String(n.value), String(n.relation_segment || '')) } catch (e) { t = '' }
        if (t) return String(t)
    }
    return String(r?.title || n.valueStr || r?.widget || n.value || '')
}

// запись, которую открывает пункт: только узел-ссылка (как двойной клик дерева: binding2 node, attr_type AttrLink)
export function tasksPanel_openOf(r, ctx) {
    const n = r?.node
    if (!n || n.attr_type !== 'AttrLink' || n.value == null || n.value === '') return null
    // IE 2026 09 23 (заказ Игоря: панель задач в шапке — названия): заголовок виджета записи — разрешённое название, иначе как раньше
    const t = (ctx && typeof ctx.titleFor === 'function' && tasksPanel_bare(r)) ? tasksPanel_titleOf(r, ctx) : ''
    return { id: String(n.value), segment: String(n.relation_segment || ''), title: String(t || n.valueStr || n.value) }
}

// действие открытия записи узла — тот же путь, что у двойного клика дерева (mainStore widget_open: id = node.value, segment = node.relation_segment);
// child — открыть подчинённым виджетом (вкладка формы стола), иначе — виджет на текущей странице стола (панель в шапке)
export function tasksPanel_openAction(open, opts = {}) {
    if (!open || !open.id) return null
    const item = { id: String(open.id), title: String(open.title || open.id) }
    if (open.segment) item.segment = String(open.segment)
    const action = { command: 'widget_open', widget: 'widget-record', _activate: true, item }
    if (opts.child) action.open_in_children_widget = true
    return action
}

// иконка сегмента (словарь SEGMENTS: pi записи; у подсегмента без своей иконки — иконка родителя), как у строк формы чипса
export function tasksPanel_segmentPi(seg, dictRow) {
    if (!seg || typeof dictRow !== 'function') return ''
    let rec = dictRow('SEGMENTS', seg), guard = 0
    while (rec && !(rec.pi || rec.doc?.pi) && rec.parent && guard++ < 6) rec = dictRow('SEGMENTS', rec.parent)
    return withPi(rec?.pi || rec?.doc?.pi || '')
}

// значок пункта — тот же, что рисует колонка Title дерева: node.pi (иконка сегмента, поставленная бэком), иначе словарь сегментов, иначе тип
export function tasksPanel_iconOf(r, hasKids, dictRow, listFolder = false) {   // IE 2026 10 24 / ODOO-348705 (заказ Игоря: иконка ссылки на список в дереве — как ярлык списка): listFolder — ctx.listFolder (fe.ux.treeListFolderOpen), без него значок как был
    const n = r?.node || {}
    const own = withPi(treeNode_pi(n, listFolder === true))   // IE 2026 10 24 / ODOO-348705 (заказ Игоря: иконка ссылки на список в дереве — как ярлык списка): ссылка на запись WIDGET-LIST — pi-folder-open
    if (own) return own
    if (n.attr_type === 'AttrLink') return (n.relation_segment && tasksPanel_segmentPi(n.relation_segment, dictRow)) || TYPE_ICON.AttrLink
    if (hasKids || n.attr_type === 'AttrTab') return TYPE_ICON.AttrTab
    return TYPE_ICON.AttrStr
}

// бейдж статуса последнего лога: название и цвет элемента словаря STATUS (как пилюля статуса в гриде), запасной цвет — cssClass-status строки (log.py)
export function tasksPanel_statusOf(r, ctx = {}) {
    const id = String(r?.status || '').trim()
    if (!id) return null
    const dictRow = typeof ctx.dictRow === 'function' ? ctx.dictRow : () => null
    const t = typeof ctx.t === 'function' ? ctx.t : identityT
    const item = dictRow('STATUS', id)
    const text = String(item?.title || item?.doc?.title || id.replace(/^STATUS-/, '').replace(/^\w/, c => c.toUpperCase()))
    const cls = String(item?.cssClass || item?.doc?.cssClass || r['cssClass-status'] || '').trim()
    let runAt = ''
    if (r.created_at) {
        try { runAt = typeof ctx.formatDate === 'function' ? stripTags(ctx.formatDate(String(r.created_at))) : String(r.created_at) } catch (e) { runAt = String(r.created_at || '') }
    }
    const title = [text, String(r.status_comment || '').trim(), runAt ? t('Run at {time}', { time: runAt }) : ''].filter(Boolean).join(' · ')
    // IE 2026 09 28 / ODOO-… (заказ Игоря: поиск в формах-меню по статусам): имена статуса на других языках — titles_alt элемента словаря STATUS (бэк get_itemsSource: база — английское название предопределённого статуса,
    // meta.title_{lang}); поиск панели (MenuPanel) ищет и по ним: «error» в интерфейсе uk находит «Помилка»
    const alt = Array.isArray(item?.titles_alt) ? [...new Set(item.titles_alt.map(v => String(v ?? '').trim()).filter(v => v && v !== text))] : []
    return alt.length ? { text, cls, title, id, alt } : { text, cls, title, id }
}

// пункты MenuPanel из строк дерева (рекурсивно): ссылка — command widget_open + _open (запись), бейдж статуса, приглушение, значок
// IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): basePath / parentRows — путь строки в дереве (индексы от корня; одна задача бывает в дереве несколько раз) и запись-владелец (ctx.paste)
// в пунктах (_path, _owner) — цель кнопок цвета / фона подсказки (utils/tipFormat.menuTarget → метод бэка menu_row_format)
export function tasksPanel_build(rows, ctx = {}, parentOff = false, basePath = null, parentRows = null) {
    const out = []
    const list = rows || []
    for (let i = 0; i < list.length; i++) {
        const r = list[i]
        if (!isObj(r)) continue
        const off = parentOff || r.use === false
        const idx = parentRows ? parentRows.indexOf(r) : i
        const path = (basePath && idx >= 0) ? basePath.concat(idx) : null
        const open = tasksPanel_openOf(r, ctx)   // IE 2026 09 23 (заказ Игоря: панель задач в шапке — названия): ctx.titleFor
        const st = tasksPanel_statusOf(r, ctx)
        const kids = tasksPanel_build(r.attrs, ctx, off, path, r.attrs)
        const it = { title: tasksPanel_titleOf(r, ctx), cssClass: tasksPanel_iconOf(r, kids.length > 0, ctx.dictRow, ctx.listFolder), disabled: off, _row: r }   // IE 2026 10 24 / ODOO-348705 (заказ Игоря: иконка ссылки на список в дереве — как ярлык списка)
        if (path) it._path = path
        if (ctx.paste && ctx.paste.record) it._owner = { record: String(ctx.paste.record), segment: String(ctx.paste.segment || '') }
        if (open) {
            it.command = 'widget_open'; it._open = open   // папка с командой — тоже ссылка (правило MenuPanel)
            // IE 2026 09 23 (заказ Игоря: кнопки в подсказках): кнопка «вставить» — строки в дерево задач записи-владельца (ctx.paste = {record, segment})
            if (ctx.paste && ctx.paste.record) it._paste = { target: 'task', record: String(ctx.paste.record), segment: String(ctx.paste.segment || ''), id: open.id }
        }
        if (st) { it.badge = st; it.tooltip = st.title }
        else if (open && open.segment) it.tooltip = open.segment
        if (kids.length) it.attrs = kids
        out.push(it)
    }
    return out
}

const pureFolder = (r) => !!(isObj(r) && Array.isArray(r.attrs) && r.attrs.length && !tasksPanel_openOf(r))

// раскладка «по-1С» — каждая чистая папка (Tab / Text без ссылки) с собственными пунктами становится своей группой (колонкой), вложенные чистые
// папки идут следом в порядке дерева; иначе один корень («Calculation» с восемью подпапками) ложился одной длинной колонкой. Ссылка с детьми
// (Link + attrs) остаётся пунктом-папкой внутри группы; пункты вне папок — в группу runsTitle (MenuPanel). Одноимённая папка — с именем родителя
export function tasksPanel_flatten(rows, ctx = {}) {
    const out = [], seen = new Set()
    const owner = (ctx.paste && ctx.paste.record) ? { record: String(ctx.paste.record), segment: String(ctx.paste.segment || '') } : null   // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки)
    const walk = (list, parentOff, parentTitle, basePath, parentRows) => {
        for (const r of list || []) {
            if (!isObj(r)) continue
            const off = parentOff || r.use === false
            const idx = parentRows ? parentRows.indexOf(r) : -1
            const path = (basePath && idx >= 0) ? basePath.concat(idx) : null   // IE 2026 09 25: путь папки в дереве
            if (!pureFolder(r)) { out.push(...tasksPanel_build([r], ctx, parentOff, basePath, parentRows)); continue }
            const own = r.attrs.filter(k => isObj(k) && !pureFolder(k))
            if (own.length) {
                const t = tasksPanel_titleOf(r, ctx)   // IE 2026 09 23 (заказ Игоря: панель задач в шапке — названия)
                const title = seen.has(t) && parentTitle ? parentTitle + ' · ' + t : t
                seen.add(t)
                const g = { title, cssClass: tasksPanel_iconOf(r, true, ctx.dictRow, ctx.listFolder), disabled: off, attrs: tasksPanel_build(own, ctx, off, path, r.attrs), _row: r }   // IE 2026 10 24 / ODOO-348705 (заказ Игоря: иконка ссылки на список в дереве — как ярлык списка)
                if (path) g._path = path
                if (owner) g._owner = owner
                const st = tasksPanel_statusOf(r, ctx); if (st) { g.badge = st; g.tooltip = st.title }
                out.push(g)
            }
            walk(r.attrs.filter(pureFolder), off, tasksPanel_titleOf(r, ctx), path, r.attrs)
        }
    }
    walk(rows, false, '', [], rows)
    return out
}

// обход всех строк дерева
export function tasksPanel_walk(rows, fn) {
    const rec = (list, depth) => { for (const r of list || []) { if (!isObj(r)) continue; fn(r, depth); rec(r.attrs, depth + 1) } }
    rec(rows, 0)
}

// сегменты узлов-ссылок без своей иконки — их записи запрашиваются в словаре SEGMENTS (значки пунктов)
export function tasksPanel_segments(rows) {
    const segs = new Set()
    tasksPanel_walk(rows, (r) => { const n = r.node; if (n && n.attr_type === 'AttrLink' && n.relation_segment && !n.pi) segs.add(String(n.relation_segment)) })
    return [...segs]
}

// снимок несёт статусы последнего лога (после log.scan_log_multi у узлов-ссылок есть ключ status — пусть и пустой)
export function tasksPanel_hasStatuses(rows) {
    let has = false
    tasksPanel_walk(rows, (r) => { if (!has && r.node && r.node.attr_type === 'AttrLink' && Object.prototype.hasOwnProperty.call(r, 'status')) has = true })
    return has
}

// задачи, чей последний запуск завершился ошибкой (STATUS-error): считаются ЗАДАЧИ — уникальные node.value узлов-ссылок (одна задача может
// входить в дерево несколько раз, как в log.scan_alarm), любой глубины, независимо от use (статус — факт последнего запуска)
export function tasksPanel_errors(rows, ctx) {
    const ids = new Set(), list = []
    tasksPanel_walk(rows, (r) => {
        const n = r.node
        if (!n || n.attr_type !== 'AttrLink' || String(r.status || '') !== STATUS_ERROR) return
        const id = String(n.value || tasksPanel_titleOf(r) || '')
        if (!id || ids.has(id)) return
        ids.add(id)
        list.push({ id, title: tasksPanel_titleOf(r, ctx), comment: String(r.status_comment || ''), created_at: String(r.created_at || ''), segment: String(n.relation_segment || '') })   // IE 2026 09 23 (названия)
    })
    return { count: ids.size, ids: [...ids], rows: list }
}

// IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц): пункт «страница настроек стола» — В САМОМ НАЧАЛЕ
// меню задач, своей группой (groupTitle, по умолчанию «Workspace») перед группами задач: простой пункт без группы ушёл бы в общую группу runsTitle
// («Tasks») вместе с задачами. Пункт — команда (command, _settingsPage: true), не запись (_open нет → нет звезды избранного и кнопок записи)
export const TASKS_SETTINGS_COMMAND = 'settingsPage_open'
export function tasksPanel_withSettings(items, opts = {}) {
    const list = Array.isArray(items) ? items : []
    if (!opts || !opts.on) return list
    const pi = opts.pi || 'pi pi-sitemap'
    const it = { title: String(opts.title || ''), cssClass: pi, command: TASKS_SETTINGS_COMMAND, _settingsPage: true }
    if (opts.tooltip) it.tooltip = String(opts.tooltip)
    if (opts.active) it.active = true
    return [{ title: String(opts.groupTitle || 'Workspace'), cssClass: pi, attrs: [it], _settingsGroup: true }, ...list]
}

// ключ личных пометок избранного — общий у вкладки формы стола и панели в шапке: tasks:<id записи стола>
export function tasksPanel_favKey(recordId) { return 'tasks:' + String(recordId || '') }

export default { tasksPanel_bare, tasksPanel_bareIds, tasksPanel_titleOf, tasksPanel_openOf, tasksPanel_openAction, tasksPanel_iconOf, tasksPanel_statusOf, tasksPanel_build, tasksPanel_flatten, tasksPanel_walk, tasksPanel_segments, tasksPanel_hasStatuses, tasksPanel_errors, tasksPanel_favKey, tasksPanel_withSettings }
